module.exports = __webpack_public_path__ + "static/media/vehicle5.4cf518cd.svg";